import { render } from "./SnippetHeader.vue?vue&type=template&id=72a26f71"
import script from "./SnippetHeader.vue?vue&type=script&lang=js"
export * from "./SnippetHeader.vue?vue&type=script&lang=js"

import "./SnippetHeader.vue?vue&type=style&index=0&id=72a26f71&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__